<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 purchases-delivery-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_DELIVERIES.EDIT_PURCHASES_DELIVERY") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchases-delivery-form
              :loading="loading"
              :purchasesDeliveryData="purchasesDelivery"
              :formErrors="formErrors"
              @purchasesDeliveriesubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PurchasesDeliveryForm from "./partials/PurchasesDeliveryForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesDelivery from "./defaultPurchasesDelivery";

export default {
  layout: "DashboardLayout",

  components: { PurchasesDeliveryForm },

  mixins: [alertLeave],

  data() {
    return {
      purchasesDelivery: cloneDeep(defaultPurchasesDelivery),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("purchasesDeliveries/get", id);
        this.purchasesDelivery =
          this.$store.getters["purchasesDeliveries/purchasesDelivery"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List PurchasesDeliveries" });
    },

    viewPurchasesDelivery() {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesDelivery",
        params: { id: this.purchasesDelivery.id },
      });
    },

    async handleSubmit(purchasesDelivery) {
      this.loading = true;
      const purchasesDeliveryData = cloneDeep(purchasesDelivery);
      if (purchasesDeliveryData.destinationWarehouse) {
        if (!purchasesDeliveryData.destinationWarehouse.id) {
          delete purchasesDeliveryData.destinationWarehouse;
        }
      }
      try {
        await this.$store.dispatch(
          "purchasesDeliveries/update",
          purchasesDeliveryData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_DELIVERIES.PURCHASES_DELIVERY_UPDATED"),
        });
        this.viewPurchasesDelivery();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
